<template>
  <div class="main-menu">
    <el-dropdown
      class="dd-menu"
      trigger="click"
      @command="handleCommand">
      <span class="el-dropdown-link">
        <i class="icon-user"/><span class="username">{{ profile.name }}</span><i
          class="el-icon-arrow-down el-icon--right"/>
      </span>
      <el-dropdown-menu
        slot="dropdown"
      >
        <router-link :to="{name:'orders'}">
          <el-dropdown-item class="border-b">Verificar activación</el-dropdown-item>
        </router-link>
        <el-dropdown-item
          command="logout"
        >Cerrar sesión
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import auth from '@/services/auth.service'

export default {
  name: 'MainMenu',
  computed: {
    profile () {
      return this.$store.getters['app/profile']
    }
  },
  methods: {
    handleCommand (command) {
      if (command === 'logout') {
        auth.logout()
        console.log(this.$router)
        this.$router.push({name: 'login'})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .main-menu {
    max-width: 100vw;
    text-align: right;
    .dd-menu {
      background-color: rgba(0,0,0,0.5);
      padding: 10px;
      .el-dropdown-link {
        cursor: pointer;
        color: #fff;
        text-shadow: 0 0 3px #000 ;
        .username {
          margin: 10px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_shared/main-menu.vue